import { Fields } from "../../types/SchemaFactory";
import { TFunction } from "i18next";
import { schemaFactory } from "./../SchemaFactory";
import { WorksCategoriesForm } from "../../domain/models/dto/WorksCategoriesDTO";
import { getMaxEnumValue } from "../../tools/EnumTools";
import { WorkCategory } from "../../domain/enums/WorkCategoryEnum";

export const worksCategoriesFields: Fields<WorksCategoriesForm> = {
    category: {
        min: 1,
        max: getMaxEnumValue(WorkCategory),
        required: true,
        placeholderKey: "",
        type: "number",
        initial: 0,
    },
};

export const worksCategoriesSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, worksCategoriesFields);
};
